import { render, staticRenderFns } from "./ClassStartingBanner.vue?vue&type=template&id=13894c7a&"
import script from "./ClassStartingBanner.vue?vue&type=script&lang=js&"
export * from "./ClassStartingBanner.vue?vue&type=script&lang=js&"
import style0 from "./ClassStartingBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports